import React from 'react';
import NewVMLastStep from './NewVMLastStep';

const NewVMLastStepContainer = ({ formikProp }) => {
  return <NewVMLastStep formikProp={formikProp} />;
};

export default NewVMLastStepContainer;
